import { render } from "./SettingLocation.vue?vue&type=template&id=42f72773"
import script from "./SettingLocation.vue?vue&type=script&lang=js"
export * from "./SettingLocation.vue?vue&type=script&lang=js"

import "./SettingLocation.vue?vue&type=style&index=0&id=42f72773&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__